// extracted by mini-css-extract-plugin
export var messageSideLeft = "_te-1";
export var stateContainer = "_te-0";